import { TimelineSectionWithChildren } from '../types'

export function sortTimelineSectionsWithChildren(
  sections: TimelineSectionWithChildren[],
): TimelineSectionWithChildren[] {
  return sections
    .map(section => ({ ...section, children: sortTimelineSectionsWithChildren(section.children) }))
    .sort((a, b) => a.startTime.compareTo(b.startTime))
}
